import './styles.scss'

import React from 'react'
import { I18n } from 'react-redux-i18n'

function InfoVerifiedEmail(props) {
  return (
    <div className='info-verified-email' onClick={props.onclick}>
      <p>{I18n.t('overview_verified_email_msg')}</p>
    </div>
  )
}

export default InfoVerifiedEmail
